(function () {
  'use strict';

  var TOKEN = 'fbf47cb05caac5';
  var LS_QUIZ_KEY    = 'trial_state';
  var LS_MANUAL_KEY  = 'byrna_user_state';
  var SS_GEO_KEY     = 'byrna_ip_state';
  var OT_FUNCTIONAL  = 'C0003';

  // ipinfo.io returns abbreviations — expand to full state name (canonical format)
  var ABBR_TO_STATE = {
    'AL': 'Alabama',        'AK': 'Alaska',         'AZ': 'Arizona',
    'AR': 'Arkansas',       'CA': 'California',      'CO': 'Colorado',
    'CT': 'Connecticut',    'DE': 'Delaware',        'DC': 'District of Columbia',
    'FL': 'Florida',        'GA': 'Georgia',         'HI': 'Hawaii',
    'ID': 'Idaho',          'IL': 'Illinois',        'IN': 'Indiana',
    'IA': 'Iowa',           'KS': 'Kansas',          'KY': 'Kentucky',
    'LA': 'Louisiana',      'ME': 'Maine',           'MD': 'Maryland',
    'MA': 'Massachusetts',  'MI': 'Michigan',        'MN': 'Minnesota',
    'MS': 'Mississippi',    'MO': 'Missouri',        'MT': 'Montana',
    'NE': 'Nebraska',       'NV': 'Nevada',          'NH': 'New Hampshire',
    'NJ': 'New Jersey',     'NM': 'New Mexico',      'NY': 'New York',
    'NC': 'North Carolina', 'ND': 'North Dakota',    'OH': 'Ohio',
    'OK': 'Oklahoma',       'OR': 'Oregon',          'PA': 'Pennsylvania',
    'PR': 'Puerto Rico',    'RI': 'Rhode Island',    'SC': 'South Carolina',
    'SD': 'South Dakota',   'TN': 'Tennessee',       'TX': 'Texas',
    'UT': 'Utah',           'VT': 'Vermont',         'VA': 'Virginia',
    'WA': 'Washington',     'WV': 'West Virginia',   'WI': 'Wisconsin',
    'WY': 'Wyoming'
  };

  function fire(state, source) {
    window.byrnaDetectedState = { state: state, source: source };
    document.dispatchEvent(new CustomEvent('byrna:stateDetected', {
      bubbles: false,
      detail: { state: state, source: source }
    }));
  }

  function hasC0003Consent() {
    var groups = window.OnetrustActiveGroups || '';
    return groups.split(',').map(function (s) { return s.trim(); }).indexOf(OT_FUNCTIONAL) > -1;
  }

  function callIpinfo() {
    if (!TOKEN) { fire(null, 'no-token'); return; }

    var signal = (typeof AbortSignal !== 'undefined' && AbortSignal.timeout)
      ? AbortSignal.timeout(8000)
      : undefined;
    fetch('https://ipinfo.io/lite/me?token=' + TOKEN, signal ? { signal: signal } : {})
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var isUS = data.country_code === 'US';
      var abbr  = isUS ? data.region_code : null;
      var state = abbr ? (ABBR_TO_STATE[abbr] || null) : null;
      if (state) sessionStorage.setItem(SS_GEO_KEY, state);
      // Success counter — the catch below reports causes but has no denominator,
      // so the geo-detect failure rate is unmeasurable without this. `label`
      // carries the outcome on element geo_detect, matching how the catch
      // reports its cause. Also covers non-US and unmapped region_code, which
      // previously resolved to source 'failed' silently.
      window.ByrnaGA4 && window.ByrnaGA4.featureView('shipping_restriction_warning', '1364', {
        surface: 'detect', element: 'geo_detect', step: 'ipinfo_fetch',
        label: state ? 'resolved' : 'no_state'
      });
      fire(state, state ? 'ipinfo' : 'failed');
    })
    .catch(function (e) {
      // Geo lookup failed (network error / 8s timeout / abort) — track so we can size
      // how many shoppers fall back to no-state messaging. (#1364)
      window.ByrnaGA4 && window.ByrnaGA4.featureError('shipping_restriction_warning', '1364', {
        surface: 'detect', element: 'geo_detect', step: 'ipinfo_fetch',
        label: (e && e.name) || 'error'
      });
      fire(null, 'failed');
    });
  }

  function resolveViaIpinfo() {
    if (hasC0003Consent()) {
      callIpinfo();
      return;
    }
    // C0003 not yet granted — wait for consent interaction
    function onConsentUpdate() {
      window.removeEventListener('OneTrustGroupsUpdated', onConsentUpdate);
      if (hasC0003Consent()) {
        callIpinfo();
      } else {
        fire(null, 'no-consent');
      }
    }
    window.addEventListener('OneTrustGroupsUpdated', onConsentUpdate);
  }

  // ── Priority 1: Quiz state (highest confidence — user confirmed) ──
  var quizState = localStorage.getItem(LS_QUIZ_KEY);
  if (quizState) { fire(quizState, 'quiz'); return; }

  // ── Priority 2: Manual CTA entry ──────────────────────────────────
  var manualState = localStorage.getItem(LS_MANUAL_KEY);
  if (manualState) { fire(manualState, 'manual'); return; }

  // ── Priority 3: sessionStorage cache (previous ipinfo result) ────
  var cachedState = sessionStorage.getItem(SS_GEO_KEY);
  if (cachedState) { fire(cachedState, 'cached'); return; }

  // ── Priority 4: ipinfo.io API — gated behind C0003 consent ───────
  var getCookie = function (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  if (getCookie('OptanonAlertBoxClosed')) {
    // Returning visitor — OneTrust may not have populated window.OnetrustActiveGroups yet
    var retries = 0;
    var interval = setInterval(function () {
      retries++;
      if (window.OnetrustActiveGroups) {
        clearInterval(interval);
        resolveViaIpinfo();
      } else if (retries > 20) {
        clearInterval(interval);
        // OneTrust never populated consent groups after ~6s — geo detection can't proceed. (#1364)
        window.ByrnaGA4 && window.ByrnaGA4.featureError('shipping_restriction_warning', '1364', {
          surface: 'detect', element: 'geo_detect', step: 'consent_timeout'
        });
        fire(null, 'failed');
      }
    }, 300);
  } else {
    // New visitor — wait for consent interaction before calling ipinfo.io
    resolveViaIpinfo();
  }

})();
